import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { WwwDirectusService } from 'www-cms';

export const giftCardsContentResolver: ResolveFn<any> = (route, state) => {
  return inject(WwwDirectusService).getGiftCardsContent();
};
